import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAASUlEQVR42n2NsQqAMAxE+//fF5LBgt2TgMWSSXKiIB2EHtzd8uAVrHOVZ8c40fsBVYWZvR8RE2htR60bRATMDCKCu08gM3/9FDcHqHvbSlgA5QAAAABJRU5ErkJggg=="};
